import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import useGoogleTagManager, { GoogleTagManagerNoScript } from './hooks/useGoogleTagManager';
import Home from "./pages/Home";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import Pets from "./pages/Pets";
import Gallery from "./pages/Gallery";
import ThingsToDo from "./pages/ThingsToDo";
import Reviews from "./pages/Reviews";
import Review from "./pages/Review";
import NotFound from "./pages/NotFound";
import './App.css';
import Banner from "./components/Banner";
import MuiNavbar from "./components/MuiNavbar";
import Footer from "./components/Footer";
import SEO from "./components/SEO";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppWithRouter />
      </Router>
    </HelmetProvider>
  );
}

function AppWithRouter() {
  useGoogleAnalytics();
  useGoogleTagManager();

  return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          width: '100vw',
          overflowX: 'hidden',
          position: 'relative',
          margin: 0,
          padding: 0
        }}>
          <SEO />
          <GoogleTagManagerNoScript />
          <div style={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
            position: 'relative'
          }}>
            <Banner />
            <MuiNavbar />
          </div>

        <main style={{
          flex: 1,
          width: '100%',
          maxWidth: '100%',
          margin: '0 auto',
          padding: 0,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 16px',
            boxSizing: 'border-box',
            position: 'relative'
          }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/pets" element={<Pets />} />
              <Route path="/things-to-do" element={<ThingsToDo />} />
              <Route path="/reviews" element={<Reviews />} />
              {/* Guest review form: linked from post-stay emails only, not in the nav or sitemap, noindex */}
              <Route path="/review" element={<Review />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </main>
        <Footer />
        </div>
  );
}

export default App;
